import red from '@material-ui/core/colors/red'
import teal from '@material-ui/core/colors/teal'

const alpha = 'a0' // 'ff' 無透過だと文字がみにくい

export const Colors = {
  Primary: {
    main: teal[700],
    light: teal[50]
  },
  Secondary: {
    main: red[700],
    light: red[50]
  },
  Tags: {
    rdocConstructs: `${'#ff8989'}${alpha}`,
    unitOfAnalysis: `${'#ff89ff'}${alpha}`,
    dsm5: `${'#ffff89'}${alpha}`,
    symptomatology: `${'#ffc489'}${alpha}`,
    compMathMethodDataType: `${'#89c4ff'}${alpha}`,
    compMathMethodExperimentalDesign: `${'#9393ff'}${alpha}`,
    compMathMethodModels: `${'#adffff'}${alpha}`
  },
  HeatMap: {
    Border: '#000000'
  },
  Error: red.A400,
  Icon: {
    Man: '#98b9f1',
    Woman: '#ffa0a0'
  },
  Background: {
    Default: '#fffefa'
  }
}
